// @core/api/endpoints/userprofile/delete_ui_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/userprofile';

/**
 * Delete UI settings for profile
 * Resets UI settings to platform defaults by removing all custom preferences. Cannot be undone.
 */
export async function DeleteUISettings(
  profile_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/settings/ui`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
